<template>
  <div>
    <el-table :height="height" :data="data" border ref="multipleTable"
      v-loading="loading" style="width: 100%" @selection-change="handleSelectionChange" stripe
      :row-key="(row) => row.guid">
        <el-table-column type="selection" :reserve-selection="true" width="40" header-align="center" align="center">
        </el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed>
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column :render-header="renderHeader" prop="medName" min-width="240" label="医疗机构标准名称" header-align="center" align="left" fixed show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.medName ||'-' }}
            </template>
        </el-table-column> 
        <el-table-column prop="sourceGuid" width="96" label="是否底库建档" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.sourceGuid?'是':'否'  }}
          </template>
        </el-table-column>
        <el-table-column prop="orgType" width="120" label="机构类别" header-align="center"  align="left">
          <template slot-scope="scope">
            {{ getOrgTypeName(scope.row.orgType) }}
          </template> 
        </el-table-column>
        <el-table-column :render-header="renderHeader1"  prop="medStandardName" min-width="240" label="其他名称" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.medStandardName||'-'}}
          </template> 
        </el-table-column>
        <el-table-column prop="orgRank" width="96" label="机构级次" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{getOrgRankName(scope.row.orgRank)}}
          </template> 
        </el-table-column>
        <el-table-column prop="orgGrade" width="96" label="机构等级" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.orgGrade | orgGrade}}
          </template> 
        </el-table-column>
        <el-table-column prop="createUserName" width="96" label="创建人" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.createUserName  }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" header-align="center" width="180" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.createTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column prop="updateUserName" width="96" label="更新人" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.updateUserName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" header-align="center" width="180" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.updateTime | getTimeDate }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="approveVO" width="96" label="审核人" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.approveVO">{{ scope.row.approveVO.approveStaffName || '-' }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="approveVO" label="审核时间" header-align="center" width="180" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.approveVO">{{ scope.row.approveVO.approveTime | getTimeDate }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="approveVO" label="审核状态" header-align="center" width="96" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.approveVO&&scope.row.approveVO.approveState" :type="type[scope.row.approveVO.approveState]">{{
              approveStateObj[scope.row.approveVO.approveState] || '-'
            }}</el-tag>
            <span v-else>{{ '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="venue" width="120" label="省" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.province | province}}</template>
          </el-table-column> 
          <el-table-column prop="venue" width="120" label="市" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.city | city}}</template>
          </el-table-column> 
          <el-table-column prop="venue" width="120" label="区/县" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.district | district}}</template>
          </el-table-column> 
          <el-table-column prop="address" label="详细地址" min-width="240" header-align="center"  align="left" show-overflow-tooltip> 
            <template slot-scope="scope">
              {{ scope.row.address ||'-' }}
            </template>
          </el-table-column> 
          <el-table-column prop="contacts" width="96" label="医院联系人" header-align="center"  align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.contacts ||'-' }}
            </template>
          </el-table-column> 
          <el-table-column prop="contactTel" width="120" label="手机号码" header-align="center"  align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.contactTel ||'-' }}
            </template> 
          </el-table-column>
          <el-table-column prop="createUserName" width="120" label="业务指派人员" header-align="center"  align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ getbelongStaffsName(scope.row) }}
            </template>
          </el-table-column> 
          <el-table-column prop="medCode" width="120" label="医疗机构编码" header-align="center" align="left">
            <template slot-scope="scope">
              {{ scope.row.medCode ||'-' }}
            </template>
          </el-table-column>


        <el-table-column label="操作" header-align="center" width="200" align="center" fixed="right">
          <template slot-scope="scope">
            <a class="txt-color" @click="toDetail(scope.row)"> 详情 | </a>
            <a class="txt-color" v-if="!scope.row.approveVO||scope.row.approveVO.approveState=='A'"  @click="toAudit(scope.row)">审核</a>
            <a class="txt-color" v-if="scope.row.approveVO&&(scope.row.approveVO.approveState=='Y'||scope.row.approveVO.approveState=='N')" @click="toAudit(scope.row)">撤回重审</a>
            <a class="txt-color"  v-if="scope.row.approveVO&&!!scope.row.approveVO.approveCount" @click="historyReviewRecords(scope.row, 'customer')"> | 查看历史审核 </a>
          </template>
        </el-table-column>
      </el-table>
  </div>
</template>

<script>
import tableMixins from './mixins/tableMixins.js';
export default {
  mixins: [tableMixins],
  props: {
    height: { // 表格高度
      type: Number,
    },
    data: { // 表格数据
      type: Array,
      default: [],
    },
    loading: { // 表格数据
      type: Boolean,
      default: false,
    },
    page: { // 表格数据
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      cityLevelList:[],
    };
  },
  created() {
    console.log('medtable');
    
    this.getFormMedConfig()
    this.getLevelList(2)
    
  },
  beforeDestroy() {
    
  },
  methods: {
    renderHeader: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'dark',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
              '机构工商注册名称'
              ],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
    renderHeader1: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'dark',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
              '机构曾用名、简称等'
              ],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
    getFormMedConfig() {
      let userInfo = JSON.parse(localStorage.userInfo);
      let query = {
        functionCode: 'YYJD',
        tenantGuid: localStorage.guid,
        organisationGuid: userInfo.organisationGuid
      }
      this.api.postJson(
        `/${serverConfig.msConfigureService}/function/function-tenant-field/get-config`,
        query
      ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = res.data.data;
          localStorage.setItem('YYJD_CONFIG', JSON.stringify(data.fieldList))
         

        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // getFieldConfig(params, key,attr) {
    //   var fieldList = JSON.parse(localStorage.getItem(attr));
    //   var newConfig = {};
    //   if (!fieldList) return
    //   fieldList.forEach((item) => {
    //     if (item.fieldName == params) {
    //       newConfig = item;
    //     }
    //   });
    //   return (newConfig && newConfig[key]) || undefined;
    // },

    //处理机构类别
    getOrgTypeName(value) {
      let orgTypeList = this.transform(this.getFieldConfig('orgType', 'selectItemList','YYJD_CONFIG'));
      let item = orgTypeList.filter(item => item.value == value)
      return item.length && item[0].name || '-';
    },
    //处理机构级次
    getOrgRankName(value) {
      let orgRankList = this.orgRankList;
      let item = orgRankList.filter(item => item.value == value)
      return item.length && item[0].text || '-';
    },
    getLevelList(type) {
      let that = this;
      that.api
        .get(
          `/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=${type == 1 ? '城市等级' : type == 2 ? '医院级别' : '会议类型'}`,
        )
        .then((resp) => {
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            data.forEach(item => {
              item.value = item.value;
            })
            type == 1 ? this.cityLevelList = data : type == 2 ? this.orgRankList = data : this.meetingTypeList = data
          }
        });
    },
   
  },
};
</script>
